import getBrowserLocale from './getBrowserLocale';
import supportedLocales from '../supported-locales';

export default function getStartingLocale() {
  const browserLocale = getBrowserLocale();
  if (supportedLocales.find(value => value.code == browserLocale)) {
    return browserLocale;
  } else {
    return process.env.VUE_APP_I18N_LOCALE || 'da';
  }
}
